import { render, staticRenderFns } from "./RecordsEmployees.vue?vue&type=template&id=3aa31f90&scoped=true"
import script from "./RecordsEmployees.vue?vue&type=script&lang=js"
export * from "./RecordsEmployees.vue?vue&type=script&lang=js"
import style0 from "./RecordsEmployees.vue?vue&type=style&index=0&id=3aa31f90&prod&lang=scss&scoped=true"
import style1 from "./RecordsEmployees.vue?vue&type=style&index=1&id=3aa31f90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa31f90",
  null
  
)

export default component.exports